import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import router from "./router";
import { global } from "./mixins";
import store from "./store";
import VueSocialSharing from "vue-social-sharing";
import i18n from "./i18n";
import VueMeta from "vue-meta";
import { Plugins } from "@capacitor/core";

// use mixins
Vue.mixin(global);
Vue.use(VueSocialSharing);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

Vue.config.productionTip = false;
if (process.env.NODE_ENV === "development") {
  Vue.config.devtools = true;
}

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
  mounted() {
    Plugins.SplashScreen.hide();
  },
}).$mount("#app");
